import { Link } from 'react-router-dom';
import { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
  showCategory?: boolean;
}

export default function VideoCard({ video, showCategory = false }: VideoCardProps) {
  const formatViews = (views: number) => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/article/${video.slug}`}
      className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
        <span className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
          {video.duration}
        </span>
        {video.isHot && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
            热门
          </span>
        )}
        {video.isNew && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
            最新
          </span>
        )}
        {video.isHot && video.isNew && (
          <>
            <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
              热门
            </span>
            <span className="absolute top-2 left-14 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
              最新
            </span>
          </>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading text-foreground-900 font-semibold text-sm leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors mb-2">
          {video.title}
        </h3>
        {showCategory && (
          <div className="mb-2">
            <span className="inline-block bg-secondary-100 text-secondary-800 text-xs px-2 py-0.5 rounded-md">
              {video.category}
            </span>
          </div>
        )}
        <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {video.description}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(video.views)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-primary-500"></i>
              {video.rating}
            </span>
          </div>
          <span>{video.date}</span>
        </div>
      </div>
    </Link>
  );
}